export const DEAL_RENT_PREPAYMENT = 'deal_rent_prepayment';
